<script lang="ts">
  import { TeoCore } from '@/teoCore/TeoCore';
  import { useHelp } from '@/ui/components/dialogs/use-help.svelte';

  import HelpOverlay from './cmps/HelpOverlay.svelte';

  let help = useHelp();

  function handleClose() {
    TeoCore.current.help.close();
  }
</script>

<HelpOverlay helpData={help.current} onClose={handleClose} />
